import styled, { css } from "styled-components";

export default styled.div(({ theme }) => css`

  &.show {
    .background {
      opacity: 0.6;
      z-index: 100;
    }
    
    .sidebar{
      display: block;
      right: 0;
    }
  }

  .footer-group {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .sidebar{
    height: 100vh;
    top: 60px;
    background: ${theme.palette.header.background};
    width: 100%;
    position: fixed;
    z-index: 100;
    right: -100%;
    transition: right 0.25s linear;

    svg {
      cursor: pointer;
    }

    .left-container {
      margin-left: 40px;
    }

    .left-container span {
      font-size: 16px;
      font-weight: ${theme.fonts.headingWeight};
      margin-right: 10px;
    }

    .left-container svg:first-child {
      margin: 0px 10px 0px 20px;
    }

    .right-container a svg,
    .right-container button svg {
      margin-right: 20px;
    }

    .right-container button {
      background: transparent;
      border: 0px;
    }

    .more-options {
      background-color: ${theme.palette.main.border};
    }

    .more-options svg {
      margin-left: 40px;
      margin-top: 15px;
    }

    .more-options div:last-child {
      padding-bottom: 15px;
    }

    .more-options span {
      margin-left: 10px;
      color: ${theme.palette.main.white};
    }
  }
  @media only screen and (min-width: ${theme.breakpoints.XM}) {
    display: none;
    
    .background, 
    .sidebar {
      display: none;
    }
    
    &.show {
      .background {
        display: none;
      }
      
      .sidebar{
        display: none;
      }
    }
  }
`);
